import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate, RISK } from "@/lib/constants";
import { RiskDot } from "@/components/RiskDot";
import { cn } from "@/lib/utils";
import { CalendarBlank, Flag } from "@phosphor-icons/react";

export default function PlanningPanel({ projectId }) {
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    api.get(`/projects/${projectId}/planning`).then((r) => setPlan(r.data)).catch(() => {});
  }, [projectId]);

  if (!plan) return <div className="rounded-xl border border-border bg-card p-6 text-muted-foreground">Se calculează…</div>;

  const feas = RISK[plan.feasibility] || RISK.verde;

  return (
    <div className="space-y-4" data-testid="planning-panel">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-4">
        <div className="rounded-xl border border-border bg-card p-5">
          <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Livrare contractuală</div>
          <div className="mt-2 font-head text-lg font-bold">{fmtDate(plan.delivery_date)}</div>
        </div>
        <div className="rounded-xl border border-border bg-card p-5">
          <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Start necesar</div>
          <div className="mt-2 font-head text-lg font-bold">{fmtDate(plan.project_start)}</div>
        </div>
        <div className="rounded-xl border border-border bg-card p-5">
          <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Buffer disponibil</div>
          <div className={cn("mt-2 font-head text-lg font-bold", plan.slack_days < 0 ? "text-red-400" : "text-foreground")}>
            {plan.slack_days} zile
          </div>
        </div>
        <div className={cn("rounded-xl border bg-card p-5", feas.ring, "ring-1")}>
          <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Fezabilitate</div>
          <div className="mt-2 flex items-center gap-2"><RiskDot level={plan.feasibility} label size="lg" /></div>
        </div>
      </div>

      <div className="rounded-xl border border-border bg-card p-6">
        <div className="mb-4 flex items-center gap-2">
          <CalendarBlank size={18} className="text-primary" />
          <h3 className="font-head text-lg font-bold">Planificare inversă (backward) · sărbători {plan.holidays_country}</h3>
        </div>
        <div className="space-y-2">
          {plan.steps.map((s, i) => (
            <div key={s.step_id} className="flex items-center gap-3 rounded-lg border border-border p-3" data-testid={`plan-step-${i}`}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/15 text-xs font-bold text-primary">
                {s.gate || i}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 text-sm font-semibold">
                  {s.name}
                  {s.critical && <Flag size={13} weight="fill" className="text-red-400" title="Drum critic" />}
                </div>
                <div className="text-xs text-muted-foreground">Responsabil: {s.role} · {s.duration_days}z + {s.buffer_days}z buffer</div>
              </div>
              <div className="text-right text-xs">
                <div className="font-medium">{fmtDate(s.start)}</div>
                <div className="text-muted-foreground">→ {fmtDate(s.end)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
